<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="inspectDeviceManage">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 设备到期提醒
        </span>
        <div class="w_normalNav">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <downloadBtn url="extra/pointInspectDevice/export/timeoutRemindDevice" :params="seefrom" method="post" :needUserId="true"></downloadBtn>
        </div>
        <div class="searchForm1">
          <el-form ref="seefrom" class="uLabelDcontent" :model="seefrom">
            <el-form-item label="设备名称:">
              <el-input placeholder="请输入设备名称" v-model="seefrom.deviceName"></el-input>
            </el-form-item>
            <el-form-item label="消防系统">
              <el-select :popper-append-to-body="false" v-model="seefrom.fireControlSystem" placeholder="请选择消防系统" clearable @change="selectFireSystem" @clear="clearFireSystem">
                <el-option v-for="item in systemList" :key="item.id" :label="item.name" :value="item.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备类型:">
              <el-select :popper-append-to-body="false" v-model="seefrom.deviceType" placeholder="请选择设备类型" style="width:100%" clearable @clear="clearDeviceType">
                <el-option v-for="(item, index) in deviceList" :key="index" :label="item.deviceType" :value="item.deviceType"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="区域选择">
              <el-input placeholder="请选择区域" v-model="seefrom.areaName" @focus="changeAreaMode(2)"></el-input>
              <!-- 区域树 -->
              <mountPoint :hasChildNodes="areaTreeMode" :dialogVisible="areaTreeVisible" @regionTreeClose="areaTreeVisible = false" @regionTreeData="selRegionData"></mountPoint>
            </el-form-item>
          </el-form>
        </div>
        <div class="tableWrapper">
          <el-table :data="tableData" style="width: 100%" class="stripeTable" height="500" ref="Table">
            <el-table-column show-overflow-tooltip :label="label" :prop="prop" :align="align" v-for="({prop,label,align}) in config" :key="prop.toString()"></el-table-column>
            <el-table-column show-overflow-tooltip label="剩余有效期" prop="remainDay">
              <template slot-scope="scope">
                <div :class="getStatusClass(scope.row.remainDay)">{{ scope.row.remainDay <= 0 ? '逾期' : scope.row.remainDay }}</div>
              </template>
            </el-table-column>
          </el-table>
          <div class="footer">
            <el-pagination layout="prev, pager, next" :page-size="10" @current-change="handleCurrentChange" :total="nTotal" :current-page="currentPage"></el-pagination>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: 'inspectDeviceManage',
  data() {
    return {
      tabName: 'inspectDeviceManage',
      seefrom: {},
      tableData: [],
      nTotal: 0,
      currentPage: 1,
      systemList: [],
      deviceList: [],
      areaTreeVisible: false,
      //区域树模式选择
      areaTreeMode: true
      //选择区域树模式 查询
    }
  },
  computed: {
    config() {
      return [
        {
          prop: 'deviceCode',
          label: '设备编码'
        },
        {
          prop: 'name',
          label: '设备名称'
        },
        {
          prop: 'fireControlSystem',
          label: '消防系统'
        },
        {
          prop: 'deviceType',
          label: '设备类型'
        },
        {
          prop: 'areaName',
          label: '区域名称'
        },
        {
          prop: 'qrCode',
          label: '二维码'
        }
      ]
    }
  },
  components: {
    mountPoint: () => import('public/mountPoint'),
    downloadBtn: () => import('public/download')
  },
  mounted() {
    this.getTableData()
    this.getSystemList()
  },
  methods: {
    getSystemList() {
      this.$axiosget('operation/dictionaryType/queryByKey', {
        params: {
          key: 'pointInspectFireCS'
        }
      }).then((res) => {
        if (res.data.status === '10000') {
          this.systemList = res.data.data ? res.data.data.list : []
        }
      })
    },
    selectFireSystem(e) {
      if (e) {
        this.$axiosget('extra/pointInspectContentItem/list', {
          params: {
            fireControlSystem: e
          }
        }).then((res) => {
          this.deviceList = res.data.data
        })
        this.$set(this.seefrom, 'deviceType', undefined)
      }
    },
    clearFireSystem() {
      this.$set(this.seefrom, 'deviceType', undefined)
      this.$set(this.seefrom, 'fireControlSystem', undefined)
      this.deviceList = []
    },
    clearDeviceType() {
      this.$set(this.seefrom, 'deviceType', undefined)
    },
    //选择区域模式变化
    changeAreaMode(mode) {
      this.areaTreeVisible = true
      if (mode === 2) this.areaTreeMode = false
      this.areaMode = mode
    },
    //区域树选择完回调
    selRegionData(a, ...b) {
      let mode = this.areaMode
      if (mode === 2) {
        this.seefrom.areaId = a.id
        this.seefrom.areaName = a.name
      }
    },
    //搜索
    subSeefrom() {
      this.currentPage = 1
      this.getTableData()
    },
    reset() {
      this.seefrom = {}
    },
    getTableData() {
      this.$axiosget('extra/pointInspectDevice/timeOutRemindPage', {
        params: {
          pageSize: 10,
          pageNum: this.currentPage,
          ...this.seefrom
        }
      }).then((res) => {
        this.tableData = res.data.data.list
        this.nTotal = res.data.data.total
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getTableData()
    },
    getStatusClass(val) {
      if (val > 3) {
        return 'greenDay'
      } else if (val > 0 && val <= 3) {
        return 'orangeDay'
      } else {
        return 'redDay'
      }
    }
  }
}
</script>

<style lang="less">
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
.el-input__inner:focus {
  border: 1px solid #3587c7;
}
</style>

<style lang="less" scoped>
.greenDay {
  color: green;
}

.orangeDay {
  color: orange;
}

.redDay {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/deviceInspect/deviceExpireRemind/index.vue